import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconBuyTicketsStyle0 = cosmosIconCss;

const CosmosIconBuyTickets$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconBuyTickets extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '59e9ad1de584bc59f177f9af2d0166b55907de25', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '407739986366b0ab2ff037762e93a4666081f7f3', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '9c9964eed1dc3f8ebce85229ff89eb727601d377', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M4.99 14.81a.51.51 0 0 1-.58-.09L2.35 12.7a.5.5 0 0 1 0-.7l9.52-9.57a.5.5 0 0 1 .71 0l2.08 2.08a.49.49 0 0 1 .09.59 1.46 1.46 0 0 0 2 2 .49.49 0 0 1 .59.09l2.11 2.1a.51.51 0 0 1 0 .71l-9.49 9.53a.51.51 0 0 1-.71 0L7.1 17.38a.48.48 0 0 1-.1-.57 1.46 1.46 0 0 0-1.3-2.19 1.38 1.38 0 0 0-.71.19Zm8.15-9.71-.91-.91L4.1 12.3l.9.91a2.93 2.93 0 0 1 2.8.79 3 3 0 0 1 .83 2.56.54.54 0 0 0 .13.44l.81.81 8.11-8.11-.94-1a2.65 2.65 0 0 1-.74.11 3 3 0 0 1-2.86-3.71ZM10.5 8.899a.5.5 0 0 1 0-.708l.353-.353a.5.5 0 0 1 .707 0l.375.375a.5.5 0 0 1 0 .707l-.354.353a.5.5 0 0 1-.707 0L10.5 8.9Zm2.124 1.408a.5.5 0 0 0 .001.707l.376.374a.5.5 0 0 0 .707 0l.353-.355a.5.5 0 0 0-.001-.707l-.375-.374a.5.5 0 0 0-.708 0l-.353.355Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconBuyTicketsStyle0; }
}, [1, "cosmos-icon-buy-tickets", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-buy-tickets"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-buy-tickets":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconBuyTickets$1);
            }
            break;
    } });
}

const CosmosIconBuyTickets = CosmosIconBuyTickets$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconBuyTickets, defineCustomElement };
